import styled from 'styled-components'
import { Map as GMMap } from 'google-maps-react'
import getBreakpoint from '@client/utils/breakpoints'

export default [
  {
    featureType: 'poi.sports_complex',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    elementType: 'geometry',
    stylers: [
      {
        color: '#ededed',
      },
    ],
  },
  {
    elementType: 'labels.icon',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#8E8E93',
      },
    ],
  },
  {
    elementType: 'labels.text.stroke',
    stylers: [
      {
        color: '#f5f5f5',
      },
    ],
  },
  {
    featureType: 'administrative.land_parcel',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#e3e3e8',
      },
    ],
  },
  {
    featureType: 'poi',
    elementType: 'geometry',
    stylers: [
      {
        color: '#eeeeee',
      },
    ],
  },
  {
    featureType: 'poi',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#9B9BA0',
      },
    ],
  },
  {
    featureType: 'poi.park',
    elementType: 'geometry',
    stylers: [
      {
        color: '#a7d0a7',
      },
    ],
  },
  {
    featureType: 'poi.park',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#eef6ec',
      },
    ],
  },
  {
    featureType: 'poi.park',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#9e9e9e',
      },
    ],
  },
  {
    featureType: 'road',
    elementType: 'geometry',
    stylers: [
      {
        color: '#ffffff',
      },
    ],
  },
  {
    featureType: 'road',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#ff0000',
      },
    ],
  },
  {
    featureType: 'road.arterial',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#9e9e9e',
      },
    ],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry',
    stylers: [
      {
        color: '#ffffff',
      },
    ],
  },
  {
    featureType: 'road.highway',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#9e9e9e',
      },
    ],
  },
  {
    featureType: 'road.local',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#ffffff',
      },
    ],
  },
  {
    featureType: 'road.local',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#9e9e9e',
      },
    ],
  },
  {
    featureType: 'transit.station',
    elementType: 'geometry',
    stylers: [
      {
        color: '#eeeeee',
      },
    ],
  },
  {
    featureType: 'water',
    elementType: 'geometry',
    stylers: [
      {
        color: '#dcecfb',
      },
    ],
  },
  {
    featureType: 'water',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#9e9e9e',
      },
    ],
  },
]

export const ButtonsWrappers = styled.section(
  ({ hasSelectedGym }) => `
  position: absolute;
  left: 20px;
  bottom: ${hasSelectedGym ? '150px;' : '20px;'};

  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 1;
  @media (min-width: ${getBreakpoint('xl')}px) {
    bottom: 20px;
  }
`
)

export const SearchWrappers = styled.section`
  position: absolute;
  left: 0;
  right: 0;
  top: 105px;

  display: flex;
  flex-direction: column;
  align-items: center;

  @media (min-width: ${getBreakpoint('xl')}px) {
    bottom: 24px;
    top: auto;
  }
`

export const BackdropWrapper = styled.section`
  .MuiBackdrop-root {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 2;
  }
`

export const Map = styled(GMMap)`
  .gm-ui-hover-effect {
    display: none !important;
  }

  .gm-style .gm-style-iw-d {
    box-sizing: border-box;
    overflow: hidden !important;
  }

  .gm-style .gm-style-iw-c {
    position: absolute;
    box-sizing: border-box;
    overflow: hidden;
    top: 0;
    left: 0;
    padding-bottom: 25px !important;
    transform: translate(-50%, -100%);
    background-color: white;
    border-radius: 0;
    padding: 0;
    box-shadow: none !important;
    background-color: #ffffff00 !important;
    display: none;
    @media (min-width: ${getBreakpoint('xl')}px) {
      display: block;
    }
  }

  .gm-style .gm-style-iw-t::after {
    display: none;
    background: linear-gradient(
      45deg,
      rgba(255, 255, 255, 1) 50%,
      rgba(255, 255, 255, 0) 51%,
      rgba(255, 255, 255, 0) 100%
    );
    box-shadow: 0;
    content: '';
    height: 0;
    left: 0;
    position: absolute;
    top: 0;
    transform: translate(-50%, -50%) rotate(-45deg);
    width: 0;
  }
`

export const InfoWindowForMobile = styled.div`
  position: absolute;
  bottom: 20px;
  width: 100%;
`
